import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, filter, shareReplay, tap } from 'rxjs';
import { TextErrorContentUI } from 'src/app/interfaces/text-content.interface';
import { ErrorService } from 'src/app/services/error/error.service';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { StoreService } from 'src/app/services/store/store.service';
import { Patterns } from 'src/app/utils/constants';
import { ErrorContentName } from 'src/app/utils/enums';
import { buildRequestGenerateOtp } from 'src/app/utils/utils';

@Component({
	selector: 'app-error',
	templateUrl: './error.component.html',
	styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
	readonly errorContentName = ErrorContentName;

	readonly vm$ = combineLatest({
		errorContent: this.errorService.errorText$,
		customerData: this.storeService.customerData$,
	}).pipe(
		filter(vm => !!vm.errorContent),
		tap(({ errorContent }) => {
			if (errorContent.tags?.page) this.gtmService.handlerEvent(errorContent.tags.page);
		}),
		shareReplay({ bufferSize: 1, refCount: true })
	);

	constructor(
		private readonly errorService: ErrorService,
		private readonly gtmService: GtmService,
		private readonly storeService: StoreService,
		private readonly router: Router
	) {}

	onButtonActionHandler(errorContent: TextErrorContentUI, companyRut?: string): void {
		if (errorContent.tags?.action) this.gtmService.handlerEvent(errorContent.tags?.action);

		if (errorContent.errorName === this.errorContentName.INVALID_TAX_FOLDER_PASSWORD && companyRut) {
			this.storeService
				.generateSendOtp(buildRequestGenerateOtp(companyRut))
				.pipe(tap(() => this.router.navigateByUrl(errorContent.button.action)))
				.subscribe();
			return;
		}

		if (Patterns.externalUrl.test(errorContent.button.action)) {
			window.location.assign(errorContent.button.action);
			return;
		}

		this.router.navigate([errorContent.button.action]);
	}
}
